/* eslint-disable eqeqeq */
import { Sticky, StickyContainer } from "react-sticky";
import { BasePage } from "../../../../framework/pages/BasePage";
import { Tabs } from "antd";
import { DetalleMuestreoModal } from "../../tabs/DetalleMuestreoModal";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { DATE_FORMAT, PAGE_MODE } from "../../../../constants/constants";
import { AgregarEstacionModal } from "../../../servicios-ejecutados/tabs/PlanificacionSejecutados/modals/AgregarEstacionModal";
import { EditarEstacionModal } from "../../../servicios-ejecutados/tabs/PlanificacionSejecutados/modals/EditarEstacionModal";
import { MessageUtil } from "../../../../util/MessageUtil";
import { LoadUtil } from "../../../../framework/util/LoadUtil";
import { RequestUtil } from "../../../../util/RequestUtil";
import { EnvConstants } from "../../../../EnvConstants";
import { ModalContext } from "../../../../provider/ModalProvider";
import { COLUMN_DEFAULT } from "../../../../framework/grid/GridFw";
import { BUTTON_DEFAULT } from "../../../../framework/bar-button/BarButtonFw";
import ConfigurarPuntosSection from "../../tabs/ConfigurarPuntosSection";
import ProcedenciaMuestraModal from "../../tabs/ProcedenciaMuestraModal";
import EquiposUtilizadosModal from "../../tabs/EquiposUtilizadosModal";
import OtrosDatosModal from "../../tabs/OtrosDatosModal";
import DatosServisiosModal from "../../tabs/DatosServisiosModal";
import { SubparametrosResultadosEmisionModal } from "./SubparametrosResultadosEmisionModal";

class CadenaEmisionPage extends BasePage {
  static contextType = ModalContext;

  constructor(props) {
    super(props);
    this.state = {
      id_doc: null,
      keyPanel: "1",
    };
    this.cambiarTabPanel = this.cambiarTabPanel.bind(this);
  }

  cambiarTabPanel(tab, id_doc) {
    this.setState({
      id_doc: id_doc,
      keyPanel: tab,
      keyPrincipal: tab,
    });
  }

  renderPage(pageApi, keyPanel) {
    const getgrid_detalle_muestreo = () =>
      pageApi.getComponent("gridDetalleMuestreo");
    const getgrid_otros_gases_contaminantes = () =>
      pageApi.getComponent("gridOtrosGasesContaminantes");
    const getform_caract_equipo_monitoreo = () =>
      pageApi.getComponent("formCaractEquipoMonitoreo");
    const { TabPane } = Tabs;

    const fnDelete6 = (value, row, index) => {
      getgrid_otros_gases_contaminantes().deleteItem(row.key);
    };

    const fnNew6 = () => {
      getgrid_otros_gases_contaminantes().addItem({}, true);
    };

    const fnUpdateItem = (data) => {
      this.context.hideModal();
      getgrid_detalle_muestreo().saveItemEditing();
      const arrMuestreo = getgrid_detalle_muestreo().getData();

      setTimeout(() => {
        arrMuestreo.forEach((el) => {
          if (data.key == el.key) {
            getgrid_detalle_muestreo().updateItem({
              ...el,
              id_estacion: data.id_estacion,
              estaciondes: data.estaciondes,
              descripcion: data.descripcion,
              COORDF: data.COORDF,
              COORDN: data.COORDN,
            });
          } else {
            getgrid_detalle_muestreo().updateItem(el);
          }
        });
      }, 0);
    };

    const gridBarHeaderButtonconfig6 = {
      fields: [
        { ...BUTTON_DEFAULT.NEW, label: `Agregar Gas`, onClick: fnNew6 },
      ],
    };

    const ConfigEstacionModal = (data, esNuevo = true, id_estacion = 0) => {
      const { showModal } = this.context;
      let obj = {};

      obj = {
        fnUpdateItem,
        data: {
          ...data,
          id_tipo_matriz:
            getgrid_detalle_muestreo()?.itemEditing?.id_tipo_matriz,
          id_empresa: getgrid_detalle_muestreo()?.itemEditing.id_empresa,
          id_estacion: id_estacion,
        },
      };

      showModal({
        title: esNuevo ? "Agregar Estación" : "Editar Estación",
        width: 350,
        maskClosable: true,
        closable: false,
        background: "white",
        component: esNuevo ? (
          <AgregarEstacionModal name={obj} getParentApi={pageApi.getApi} />
        ) : (
          <EditarEstacionModal name={obj} getParentApi={pageApi.getApi} />
        ),
      });
    };

    const ConfiguResultadosModal = (data) => {
      const { showModal } = this.context;
      let obj = data;
      showModal({
        width: 800,
        maskClosable: false,
        component: (
          <SubparametrosResultadosEmisionModal
            name={obj}
            getParentApi={pageApi.getApi}
          />
        ),
      });
    };

    const gridDetalleMuestreo = (pageApi) => ({
      title: "Detalles de muestreo",
      showIndex: true,
      autoLoad: true,
      pagination: {
        server: false,
        showSizeChanger: true,
      },
      rowId: "ID_MUESTREO",
      load: {
        queryId: 921,
        params: () => {
          return {
            ID_CADENA: pageApi.getParamId(),
          };
        },
        hideMessageError: true,
      },
      save: {
        queryId: 416,
      },
      fields: [
        { name: "muestra", label: "Muestra" },
        {
          type: "select",
          name: "id_estacion",
          labelName: "estaciondes",
          label: "Estación",
          column: 3,
          load: {
            queryId: 846,
            params: () => {
              return {
                id_empresa: getgrid_detalle_muestreo()?.itemEditing?.id_empresa,
                id_tipo_matriz:
                  getgrid_detalle_muestreo()?.itemEditing?.id_tipo_matriz,
              };
            },
          },
          search: true,
          editable: true,

          onChange: async (value, values, formApi) => {
            if (value == 0) {
              ConfigEstacionModal(formApi.getData(), true);
              formApi.setFieldData("id_estacion", null);
              formApi.setFieldData("descripcion", null);
              formApi.setFieldData("COORDF", null);
              formApi.setFieldData("COORDN", null);
            } else if (value == -1) {
              const id_estacion =
                getgrid_detalle_muestreo()?.itemEditing.id_estacion;
              const estaciondes =
                getgrid_detalle_muestreo()?.itemEditing.estaciondes;

              if (!id_estacion) {
                formApi.setFieldData("id_estacion", null);
                formApi.setFieldData("estaciondes", null);
                formApi.setFieldData("descripcion", null);
                formApi.setFieldData("COORDF", null);
                formApi.setFieldData("COORDN", null);
                return MessageUtil(
                  "warning",
                  "Advertencia",
                  "Debe seleccionar primero una estaciòn para poder editar.",
                );
              }

              fnUpdateItem({ ...formApi.getData(), id_estacion, estaciondes });
              ConfigEstacionModal(
                { ...formApi.getData(), id_estacion, estaciondes },
                false,
                id_estacion,
              );
              formApi.setFieldData("id_estacion", id_estacion);
              formApi.setFieldData("estaciondes", estaciondes);
            } else {
              const id_estacion = value;
              let label = formApi
                ?.getFieldApi("id_estacion")
                ?.getSelectedItem()?.label;
              let descripcion = formApi
                ?.getFieldApi("id_estacion")
                ?.getSelectedItem()?.descripcion;

              const reqParams = LoadUtil.getReqParams({
                queryId: 138,
                params: {
                  ID_ESTACION: id_estacion,
                },
              });

              const data = await RequestUtil.postData(
                EnvConstants.GET_URL_READ(),
                reqParams,
              )
                .then((resp) => resp.dataObject)
                .catch(() => []);

              formApi.setFieldData("COORDF", data?.COORDF);
              formApi.setFieldData("COORDN", data?.COORDN);
              formApi.setFieldData("id_estacion", value);
              formApi.setFieldData(
                "estacionDes",
                label || formApi.values.label,
              );
              formApi.setFieldData(
                "descripcion",
                descripcion || formApi.values.descripcion,
              );

              if (formApi.values.id_estacion !== value) {
                fnUpdateItem({
                  ...formApi.getData(),
                  id_estacion,
                  estaciondes: label,
                  descripcion,
                  COORDF: data?.COORDF,
                  COORDN: data?.COORDN,
                });
              }
            }
          },
        },
        { name: "descripcion", label: "Descripción" },
        {
          type: "date",
          name: "fecha_prevista_muestreo",
          label: "Fecha Inicio Diurno",
          editable: true,
          format: "DD/MM/YYYY",
          inputFormat: DATE_FORMAT.YYYYMMDD,
        },
        { name: "georeferencia", label: "Georeferencia" },
        {
          name: "altura_chimenea",
          label: "Altura de chimenea",
          editable: true,
        },
        {
          name: "parametro_chimenea",
          label: "Parametro de chimenea",
          editable: true,
        },
        { name: "presion_mmhg", label: "Presión (mmHg)", editable: true },
        { name: "temperatura", label: "Temperatura (°C)", editable: true },
        {
          type: "select",
          name: "tipo_fuente",
          label: "Tipo de Fuente",
          load: { queryId: 455 },
          labelName: "tipo_fuente_des",
          editable: true,
        },
        {
          type: "select",
          name: "tipo_combustible",
          label: "Tipo de Combustible",
          load: { queryId: 456 },
          labelName: "tipo_combustible_des",
          editable: true,
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    });

    const renderTabBar = (props, DefaultTabBar) => (
      <Sticky bottomOffset={80}>
        {({ style }) => (
          <DefaultTabBar
            {...props}
            className="site-custom-tab-bar"
            style={style}
          />
        )}
      </Sticky>
    );

    const formCaractEquipoMonitoreo = (pageApi) => ({
      layout: "vertical",
      load: {
        queryId: 958,
        params: { id_cadena: pageApi.getParamId() },
      },
      save: {
        queryId: 959,
        hideMessage: true,
        hideMessageError: true,
        params: { id_cadena: pageApi.getParamId() },
        fnOk: () => {
          getform_caract_equipo_monitoreo().load()
        },
      },
      title: "Características del equipo monitoreado",
      collapsible: true,
      fields: [
        {
          name: "tipo_equipo_monitoreo",
          label: "Tipo",
          column: 4,
        },
        {
          name: "marca_equipo_monitoreo",
          label: "Marca",
          format: DATE_FORMAT.YYYYMMDD,
          inputFormat: DATE_FORMAT.YYYYMMDD,
          column: 4,
        },
        {
          name: "nro_serie_equipo_monitoreo",
          label: "Nro Serie",
          format: DATE_FORMAT.HHmm,
          inputFormat: DATE_FORMAT.HHmm,
          column: 4,
        },
        {
          name: "modelo_equipo_monitoreo",
          label: "Modelo",
          column: 4,
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    });

    const formGasesCombustion = (pageApi) => ({
      title: "Gases en Combustión",
      layout: "vertical",
      autoLoad: true,
      load: {
        queryId: 922,
        params: { ID_CADENA: pageApi.getParamId() },
        hideMessage: true,
        hideMessageError: true,
      },
      save: {
        queryId: 923,
        params: { ID_CADENA: pageApi.getParamId() },
        hideMessage: true,
        hideMessageError: true,
      },
      fields: [
        {
          type: "date",
          name: "hora_autozero",
          label: "Autozero",
          column: 3,
          inputFormat: DATE_FORMAT.HHmm,
          format: DATE_FORMAT.HHmm,
        },
        {
          type: "date",
          name: "hora_uno",
          label: "1",
          column: 3,
          inputFormat: DATE_FORMAT.HHmm,
          format: DATE_FORMAT.HHmm,
        },
        {
          type: "date",
          name: "hora_dos",
          label: "2",
          column: 3,
          inputFormat: DATE_FORMAT.HHmm,
          format: DATE_FORMAT.HHmm,
        },
        {
          type: "date",
          name: "hora_tres",
          label: "3",
          column: 3,
          inputFormat: DATE_FORMAT.HHmm,
          format: DATE_FORMAT.HHmm,
        },
      ],
    });

    const gridGasesCombustion = (pageApi) => ({
      showIndex: true,
      autoLoad: true,
      rowId: "id",
      pagination: {
        server: false,
        showSizeChanger: true,
      },
      load: {
        queryId: 500,
        params: { ID_CADENA: pageApi.getParamId() },
        hideMessage: true,
        hideMessageError: true,
      },
      save: {
        queryId: 458,
        hideMessage: true,
        hideMessageError: true,
      },
      fields: [
        { name: "muestra", label: "Muestra", width: 100 },
        { name: "tipo_ensayo", label: "Parámetro", width: 100 },
        {
          ...COLUMN_DEFAULT.OPTIONS,
          label: "Opciones",
          title: "Ingresar Resultados",
          color: "blue",
          width: 100,
          onClick: (value, row) => {
            pageApi.showModal(ConfiguResultadosModal(row));
          },
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    });

    const formCondicionEstandarConfig = (pageApi) => ({
      title: "Resultados Expresados a Condición Estándar",
      layout: "vertical",
      autoLoad: true,
      load: {
        queryId: 922,
        params: { ID_CADENA: pageApi.getParamId() },
        hideMessage: true,
        hideMessageError: true,
      },
      save: {
        queryId: 923,
        params: { ID_CADENA: pageApi.getParamId() },
        hideMessage: true,
        hideMessageError: true,
      },
      fields: [
        { name: "p_condicion_estandar", label: "P", column: 4 },
        { name: "t_condicion_estandar", label: "T", column: 4 },
      ],
    });

    const gridCondicionEstandarConfig = (pageApi) => ({
      showIndex: true,
      autoLoad: true,
      pagination: {
        server: false,
        showSizeChanger: true,
      },
      rowId: "id_detail_gases_combustion",
      load: {
        queryId: 608,
        params: { ID_CADENA: pageApi.getParamId(), tipo_condicion: 1 },
        hideMessage: true,
        hideMessageError: true,
      },
      save: {
        queryId: 609,
        params: { ID_CADENA: pageApi.getParamId(), tipo_condicion: 1 },
        hideMessage: true,
        hideMessageError: true,
      },
      fields: [
        { name: "parametro", label: "Parámetro", width: 100 },
        { name: "sub_parametro", label: "Sub Parámetro", width: 100 },
        {
          type: "select",
          name: "um_id",
          label: "Unidad Medida",
          width: 100,
          labelName: "desUM",
          column: 4,
          search: true,
          editable: true,
          load: { queryId: 583 },
        },
        {
          name: "resultado_1",
          label: "Resultado 1",
          width: 100,
          editable: true,
        },
        {
          name: "resultado_2",
          label: "Resultado 2",
          width: 100,
          editable: true,
        },
        {
          name: "resultado_3",
          label: "Resultado 3",
          width: 100,
          editable: true,
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    });

    const formCondicionNormal = (pageApi) => ({
      title: "Resultados Expresados a Condición Normales",
      layout: "vertical",
      autoLoad: true,
      load: {
        queryId: 922,
        params: { ID_CADENA: pageApi.getParamId() },
        hideMessage: true,
        hideMessageError: true,
      },
      save: {
        queryId: 923,
        params: { ID_CADENA: pageApi.getParamId() },
        hideMessage: true,
        hideMessageError: true,
      },
      fields: [
        { name: "p_condicion_normal", label: "P", column: 4 },
        { name: "t_condicion_normal", label: "T", column: 4 },
      ],
    });

    const gridCondicionNormal = (pageApi) => ({
      showIndex: true,
      autoLoad: true,
      pagination: {
        server: false,
        showSizeChanger: true,
      },
      rowId: "id_detail_gases_combustion",
      load: {
        queryId: 608,
        params: { ID_CADENA: pageApi.getParamId(), tipo_condicion: 2 },
        hideMessage: true,
        hideMessageError: true,
      },
      save: {
        queryId: 609,
        params: { ID_CADENA: pageApi.getParamId(), tipo_condicion: 2 },
        hideMessage: true,
        hideMessageError: true,
      },
      fields: [
        { name: "parametro", label: "Parámetro", width: 100 },
        { name: "sub_parametro", label: "Sub Parámetro", width: 100 },
        {
          type: "select",
          name: "um_id",
          label: "Unidad Medida",
          width: 100,
          labelName: "desUM",
          column: 4,
          search: true,
          editable: true,
          load: { queryId: 583 },
        },
        {
          name: "resultado_1",
          label: "Resultado 1",
          width: 100,
          editable: true,
        },
        {
          name: "resultado_2",
          label: "Resultado 2",
          width: 100,
          editable: true,
        },
        {
          name: "resultado_3",
          label: "Resultado 3",
          width: 100,
          editable: true,
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    });

    const gridOtrosParametros = (pageApi) => ({
      title: "Otros Parámetros",
      showIndex: true,
      autoLoad: true,
      pagination: {
        server: false,
        showSizeChanger: true,
      },
      rowId: "id_detail_gases_combustion",
      load: {
        queryId: 608,
        params: { ID_CADENA: pageApi.getParamId(), tipo_condicion: 3 },
        hideMessage: true,
        hideMessageError: true,
      },
      save: {
        queryId: 609,
        params: { ID_CADENA: pageApi.getParamId(), tipo_condicion: 3 },
        hideMessage: true,
        hideMessageError: true,
      },
      fields: [
        { name: "parametro", label: "Parámetro", width: 100 },
        { name: "sub_parametro", label: "Sub Parámetro", width: 100 },
        {
          type: "select",
          name: "um_id",
          label: "Unidad Medida",
          width: 100,
          labelName: "desUM",
          column: 4,
          search: true,
          editable: true,
          load: { queryId: 583 },
        },
        {
          name: "resultado_1",
          label: "Resultado 1",
          width: 100,
          editable: true,
        },
        {
          name: "resultado_2",
          label: "Resultado 2",
          width: 100,
          editable: true,
        },
        {
          name: "resultado_3",
          label: "Resultado 3",
          width: 100,
          editable: true,
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    });

    const gridOtrosGasesContaminantes = (pageApi) => ({
      title: "6. Otros Gases Contaminantes",
      showIndex: true,
      autoLoad: true,
      pagination: {
        server: false,
        showSizeChanger: true,
      },
      rowId: "ID_GAS_CONTAMINANTE",
      barHeader: gridBarHeaderButtonconfig6,
      load: {
        queryId: 462,
        params: { ID_CADENA: pageApi.getParamId() },
        hideMessageError: true,
      },
      save: {
        queryId: 459,
        params: { ID_CADENA: pageApi.getParamId() },
        hideMessage: true,
        hideMessageError: true,
      },
      fields: [
        { name: "VOCS", label: "VOCS", width: 100, editable: true },
        { name: "BENCENO", label: "Benceno", width: 100, editable: true },
        { name: "HCT", label: "HCT", width: 100, editable: true },
        { name: "HEXANO", label: "HEXANO", width: 100, editable: true },
        {
          name: "OTRO_PARAMETRO",
          label: "Otro Parámetro",
          width: 100,
          editable: true,
        },
        {
          name: "TIEMPO_TOTAL",
          label: "Tiempo Total de muestreo(min)",
          width: 100,
          editable: true,
        },
        {
          name: "CAUDAL",
          label: "Caudal de muestreo(1/min)",
          width: 100,
          editable: true,
        },
        {
          name: "OBSERVACIONES",
          label: "Observaciones",
          width: 100,
          editable: true,
        },
        {
          ...COLUMN_DEFAULT.DELETE,
          label: "Opciones",
          onClick: fnDelete6,
          confirm: false,
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    });

    const gridsConfigDetalleMuestreo = [
      {
        name: "gridDetalleMuestreo",
        config: gridDetalleMuestreo(pageApi),
        type: "grid",
      },
      {
        name: "formGasesCombustion",
        config: formGasesCombustion(pageApi),
        type: "form",
      },
      {
        name: "gridGasesCombustion",
        config: gridGasesCombustion(pageApi),
        type: "grid",
      },
      {
        name: "formCondicionEstandar",
        config: formCondicionEstandarConfig(pageApi),
        type: "form",
      },
      {
        name: "gridCondicionEstandar",
        config: gridCondicionEstandarConfig(pageApi),
        type: "grid",
      },
      {
        name: "formCondicionNormal",
        config: formCondicionNormal(pageApi),
        type: "form",
      },
      {
        name: "gridCondicionNormal",
        config: gridCondicionNormal(pageApi),
        type: "grid",
      },
      {
        name: "gridOtrosParametros",
        config: gridOtrosParametros(pageApi),
        type: "grid",
      },
      {
        name: "gridOtrosGasesContaminantes",
        config: gridOtrosGasesContaminantes(pageApi),
        type: "grid",
      },
    ];

    const gridsEquipos = [
      {
        name: "formCaractEquipoMonitoreo",
        config: formCaractEquipoMonitoreo(pageApi),
        type: "form",
      },
    ];

    return (
      <StickyContainer>
        <Tabs
          destroyInactiveTabPane={true}
          activeKey={this.state.keyPanel}
          renderTabBar={renderTabBar}
          onChange={(key) => this.setState({ keyPanel: key })}
        >
          <TabPane tab="Configurar Puntos" key="1">
            <ConfigurarPuntosSection
              api={pageApi}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
            />
          </TabPane>

          <TabPane
            tab="Datos del Servicio"
            key="2"
            disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}
          >
            <DatosServisiosModal
              api={pageApi}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
            />
          </TabPane>

          <TabPane
            tab="Procedencia de la muestra"
            key="3"
            disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}
          >
            <ProcedenciaMuestraModal
              api={pageApi}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
            />
          </TabPane>

          <TabPane
            tab="Detalle del muestreo"
            key="4"
            disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}
          >
            <DetalleMuestreoModal
              api={pageApi}
              data={{ ...pageApi.name }}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
              gridsConfig={gridsConfigDetalleMuestreo}
            />
          </TabPane>

          <TabPane
            tab="Equipos Utilizados"
            key="5"
            disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}
          >
            <EquiposUtilizadosModal
              api={pageApi}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
              gridsConfig={gridsEquipos}
            />
          </TabPane>

          <TabPane
            tab="Otros Datos"
            key="6"
            disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}
          >
            <OtrosDatosModal
              api={pageApi}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
            />
          </TabPane>
        </Tabs>
      </StickyContainer>
    );
  }
}

export default withRouter(CadenaEmisionPage);
